var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 70,
    viewBox: "0 0 107 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 69.5,
    fill: "#1F1F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 42.6875H60.6875V27.3125H45.3125V42.6875ZM50.9375 31.3273C50.9375 31.107 51.193 30.9828 51.3664 31.1211L56.0398 34.7938C56.071 34.8183 56.0963 34.8496 56.1136 34.8854C56.131 34.9211 56.14 34.9603 56.14 35C56.14 35.0397 56.131 35.0789 56.1136 35.1146C56.0963 35.1504 56.071 35.1817 56.0398 35.2062L51.3664 38.8812C51.193 39.0172 50.9375 38.8953 50.9375 38.675V31.3273Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.625 25.625H44.375C43.9602 25.625 43.625 25.9602 43.625 26.375V43.625C43.625 44.0398 43.9602 44.375 44.375 44.375H61.625C62.0398 44.375 62.375 44.0398 62.375 43.625V26.375C62.375 25.9602 62.0398 25.625 61.625 25.625ZM60.6875 42.6875H45.3125V27.3125H60.6875V42.6875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3664 38.8813L56.0398 35.2063C56.071 35.1817 56.0963 35.1504 56.1136 35.1146C56.131 35.0789 56.14 35.0397 56.14 35C56.14 34.9603 56.131 34.9211 56.1136 34.8854C56.0963 34.8497 56.071 34.8183 56.0398 34.7938L51.3664 31.1211C51.193 30.9828 50.9375 31.107 50.9375 31.3273V38.675C50.9375 38.8953 51.193 39.0172 51.3664 38.8813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPattern);
export default __webpack_public_path__ + "static/media/thumbnail-pattern.c8da75a16b347d00b24da734e71e4ba4.svg";
export { ForwardRef as ReactComponent };